import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CardFront from '../imgs/projects/redwood9.jpg'
import CardBack from '../imgs/projects/redwood3.jpg'

const styles = theme => ({
    container: {
        color: '#393287'
    },
    left_bar: {
        width: 200
    },
    content: {
        width: '100%'
    },
    img: {
        width: '100%'
    },
    title: {
        marginBottom: 30,
        color: '#393287',
        fontSize: 18,
        fontWeight: 'bold'
    },
    p: {
        marginTop: 20,
        color: '#393287',
        fontSize: 16
    },
    p2: {
        marginTop: 0,
        color: '#393287'
    },
    ul: {
        marginBlockStart: 0
    },
    details: {
        paddingLeft: 10
    }
})

class Home extends React.Component{
    render(){
        const {classes} = this.props

        return (
            <Grid container>
                <Grid item md={4} sm={12}>
                    <Typography variant="title" className={classes.p}>
                        Bath & Kitchen Design
                    </Typography>
                    <Typography variant="title" className={classes.p}>
                        We can help on:
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        <ul className={classes.ul}>
                            <li>Space Planning</li>
                            <li>Flooring: tile, hardwood, laminate, vinyl, carpeting, area rugs and more</li>
                            <li>Tile, Granite and Quartz: for kitchen counters, backsplashes, tubs, showers</li>
                            <li>Custom cabinet and vanity design: layout, style, color</li>
                            <li>Fabrics: for custom window treatments, upholstery, custom shower curtains, bedding, table linens</li>
                            <li>Lighting: Update your current light fixtures or add new ambient, task and decorative accent lighting</li>
                            <li>Wall treatments: paint colors, wall coverings, murals and specialty finishes</li>
                            <li>Custom Window Treatments: blinds, shutters, Roman shades, sheers, draperies, valances and more</li>
                        </ul>
                    </Typography>
                </Grid>
                <Grid item md={8} sm={12} className={classes.details}>
                    <img src={CardFront} className={classes.img}/>
                    <img src={CardBack} className={classes.img}/>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(Home)